import React from 'react';
import { styles } from './ShipmentStatusLabel.css';
import { Icon, IconName } from '@jbhi-fi/lanyard-ui/components/Icon';

export type ShipmentStatusLabelProps = {
  label: string;
  icon?: IconName;
  color?: React.CSSProperties['color'];
};

export const ShipmentStatusLabel = ({ icon, label, color = 'inherit' }: ShipmentStatusLabelProps) => {
  return (
    <p className={styles.status({ isBold: Boolean(icon) })} style={{ color: color }}>
      {icon ? <Icon name={icon} fallback={null} placeholder={null} /> : null}
      {label}
    </p>
  );
};
